import { ANTECEDENTES, PEDIDO_SERVICIO, PREGUNTAS, RESUMEN, SELECCIONAR_SOCIO, SINTOMAS, VERIFICAR_DATOS } from "./constants";

export const stepper: Record<string, number> = {
  [SELECCIONAR_SOCIO]: 1,
  [ANTECEDENTES]: 2,
  [VERIFICAR_DATOS]: 3,
  [SINTOMAS]: 4,
  [PREGUNTAS]: 5,
  [RESUMEN]: 6,
  [PEDIDO_SERVICIO]: 7
};

export const total = new Set(Object.values(stepper)).size;